module.exports = __webpack_public_path__ + "img/next-arrow-w.6dc2c08e.svg";